import React from 'react';
import { ButtonProps, SharingOutlined } from '@landr/maestro';
import { t } from '@lingui/macro';
import { ActionButton } from 'components/ActionButton';
import { AuthenticatedActions } from 'types';
import { noop } from 'utils/noop';
import useShareCreatorButton from 'components/Creator/ShareCreator/useShareCreatorButton';

export interface ShareCreatorProps extends Partial<ButtonProps> {
    interactionSource?: string;
    selectedSamples?: string[];
    onClick?: () => void;
    label?: string;
    children?: React.ReactElement;
    actionType?: AuthenticatedActions;
}

export const ShareCreator: React.FC<ShareCreatorProps> = ({
    actionType,
    onClick = noop,
    ...props
}): JSX.Element => {
    const { handleClick } = useShareCreatorButton({ onClick });

    return (
        <ActionButton
            icon={SharingOutlined}
            onClick={handleClick}
            authOnly
            userAction={{
                type: actionType || '',
                description: t`share your track`,
                args: [],
            }}
            aria-label={t`Share your track`}
            label={t`Share your track`}
            {...props}
        />
    );
};
